/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, defineMessages } from 'react-intl';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/time-since-posted.scss';

const messages = defineMessages({
    day: {
        id: 'content.posted_ago_variable.day',
        description: 'variable for the time since the content was posted',
        defaultMessage: '{day, plural,=0 {just now} one {day ago} other {days ago}}',
    },
    week: {
        id: 'content.posted_ago_variable.week',
        description: 'variable for the time since the content was posted',
        defaultMessage: '{week, plural,=0 {1 week} one {week} other {weeks}} ago',
    },
    month: {
        id: 'content.posted_ago_variable.month',
        description: 'variable for the time since the content was posted',
        defaultMessage: '{month, plural,=0 {1 month} one {month} other {months}} ago',
    },
    year: {
        id: 'content.posted_ago_variable.year',
        description: 'variable for the time since the content was posted',
        defaultMessage: '{year, plural,=0 {1 year} one {year} other {years}} ago',
    },
});

const propTypes = {
    date: PropTypes.node.isRequired, //eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const TimeSincePosted = ({ date, className }) => {
    const getDaysSincePosted = day => {
        const msPerDay = 1000 * 60 * 60 * 24;

        const postedDate = new Date(day);
        const todayDate = new Date();

        const diffMs = Math.abs(todayDate - postedDate);
        const diffDays = Math.ceil(diffMs / msPerDay);

        return diffDays;
    };

    const getDiffUnit = diffDay => {
        if (diffDay < 7) {
            return diffDay;
        }
        if (diffDay < 30) {
            return Math.ceil(diffDay / 7);
        }
        if (diffDay < 365) {
            return Math.ceil(diffDay / 30);
        }
        return Math.ceil(diffDay / 365);
    };

    const getDiffVariable = diffDay => {
        if (diffDay < 7) {
            return (
                <FormattedMessage
                    {...messages.day}
                    values={{
                        day: diffDay,
                    }}
                />
            );
        }
        if (diffDay < 30) {
            return (
                <FormattedMessage
                    {...messages.week}
                    values={{
                        week: diffDay,
                    }}
                />
            );
        }
        if (diffDay < 365) {
            return (
                <FormattedMessage
                    {...messages.month}
                    values={{
                        month: diffDay,
                    }}
                />
            );
        }
        return (
            <FormattedMessage
                {...messages.year}
                values={{
                    year: diffDay,
                }}
            />
        );
    };

    const daysSincePosted = getDaysSincePosted(date);

    const diffUnit = getDiffUnit(daysSincePosted);
    const diffVariable = getDiffVariable(daysSincePosted);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            posted {diffUnit} {diffVariable}
        </div>
    );
};

TimeSincePosted.propTypes = propTypes;
TimeSincePosted.defaultProps = defaultProps;

export default TimeSincePosted;
